<template>
  <div class="costDetail">
    <vxe-grid
      border
      show-overflow
      resizable
      ref="costDetail"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :max-height="tableHeight"
      :columns="columnList"
      :edit-config="canEdit ? { trigger: 'click', mode: 'row' } : null"
      show-footer
      :footer-method="footerMethod"
      column-min-width="120"
    >
    </vxe-grid>
    <base-form
      v-model="formData"
      :options="formDataOptions"
      ref="profitAndLoss"
      label-width="105px"
      style="margin-top: 20px"
      :disabled="!canEdit"
    ></base-form>
  </div>
</template>
<script>
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  import BaseForm from '@/components/form/base-form';
  // import API from '@/api/capitalCenter/settle';
  import fullScreenDialog from '@/common/mixins/fullScreenDialog.js';
  export default {
    mixins: [fullScreenDialog],
    name: 'costDetail',
    props: ['canEdit'],
    components: {
      // inputNumberAd,
      BaseForm,
    },
    data() {
      return {
        tableData: [],
        formData: {
          profitAndLoss: null,
        },
      };
    },
    computed: {
      columnList() {
        return [
          { type: 'seq', width: 60, title: this.$t('table.index'), fixed: 'left' }, // 序号
          { field: 'expenseType', title: this.$t('statementsAdd.costDetail.expenseType') }, // 费用类型
          {
            field: 'payableAmount',
            title: this.$t('statementsAdd.costDetail.payableAmount'), // 应付金额
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.payableAmount)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.payableAmount}
                    clearable={true}
                    max={9999999999.99}
                    min={-99999999999.99}
                    onInput={(val) => this.chooseTable(val, row, 'payableAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            field: 'payedAmount',
            title: this.$t('statementsAdd.costDetail.payedAmount'), // 已付金额
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.payedAmount)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.payedAmount}
                    clearable={true}
                    max={9999999999.99}
                    min={-99999999999.99}
                    onInput={(val) => this.chooseTable(val, row, 'payedAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            field: 'unpayAmount',
            title: this.$t('statementsAdd.costDetail.unpayAmount'), // 未付金额
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.unpayAmount)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.unpayAmount}
                    clearable={true}
                    max={9999999999.99}
                    min={-99999999999.99}
                    onInput={(val) => this.chooseTable(val, row, 'unpayAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            field: 'receivableAmount',
            title: this.$t('statementsAdd.costDetail.receivableAmount'), // 可收金额
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.receivableAmount)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.receivableAmount}
                    clearable={true}
                    max={9999999999.99}
                    min={-99999999999.99}
                    onInput={(val) => this.chooseTable(val, row, 'receivableAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            field: 'receivedAmount',
            title: this.$t('statementsAdd.costDetail.receivedAmount'), // 已收金额
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.receivedAmount)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.receivedAmount}
                    clearable={true}
                    max={9999999999.99}
                    min={-99999999999.99}
                    onInput={(val) => this.chooseTable(val, row, 'receivedAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            field: 'unreceiveAmount',
            title: this.$t('statementsAdd.costDetail.unreceiveAmount'), // 未收金额
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.unreceiveAmount)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.unreceiveAmount}
                    clearable={true}
                    max={9999999999.99}
                    min={-99999999999.99}
                    onInput={(val) => this.chooseTable(val, row, 'unreceiveAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          { field: 'currencyName', title: this.$t('statementsAdd.costDetail.currencyName') }, // 币别
          {
            // 税率
            field: 'benchmarkRate',
            title: this.$t('statementsAdd.costDetail.benchmarkRate'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.benchmarkRate, this.$globalVar.tPoint)}
                  </span>,
                ];
              },
            },
          },
        ];
      },
      formDataOptions() {
        return [
          {
            // 盈亏说明
            type: 'textarea',
            label: this.$t('statementsAdd.costDetail.profitAndLoss'),
            prop: 'profitAndLoss',
            span: 20,
            maxlength: 200,
          },
        ];
      },
    },
    methods: {
      chooseTable(val, row, prop) {
        row[prop] = val;
        if (prop == 'payableAmount' || prop == 'payedAmount') {
          row.unpayAmount = this.calcUnAmount(row.payableAmount, row.payedAmount);
        }
        if (prop == 'receivableAmount' || prop == 'receivedAmount') {
          row.unreceiveAmount = this.calcUnAmount(row.receivableAmount, row.receivedAmount);
        }
        this.updateData();
      },
      calcUnAmount(minuend, subtrahend) {
        let val = this.$cal.calCommon(minuend, subtrahend, '-', 'amount');
        return val;
      },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('batchAdd.fundsInterests.sumName');
            }
            if (
              [
                'payableAmount',
                'payedAmount',
                'unpayAmount',
                'receivableAmount',
                'receivedAmount',
                'unreceiveAmount',
              ].includes(column.property)
            ) {
              let subtrahend = 0;
              for (let i = 0; i < data.length; i++) {
                subtrahend = this.$cal.calCommon(data[i][column.property], subtrahend, '+');
              }
              return this.$baseRequest.formatTableColumn(subtrahend);
            }
            return null;
          }),
        ];
      },
      updateData() {
        this.$refs.costDetail.updateData();
      },
      importDetail(detail) {
        // 导入数据
        this.tableData = detail.orderSettleSlipExpenseList;
        this.formData.profitAndLoss = detail.profitAndLoss;
      },
      exportChildData() {
        return {
          orderSettleSlipExpenseList: this.$refs.costDetail.getTableData().fullData,
          profitAndLoss: this.formData.profitAndLoss,
        };
      },
    },
  };
</script>
